var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_2915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1499 11C21.1499 5.75311 16.8968 1.5 11.6499 1.5C6.40302 1.5 2.1499 5.75311 2.1499 11C2.1499 16.2469 6.40302 20.5 11.6499 20.5V22C5.57459 22 0.649902 17.0753 0.649902 11C0.649902 4.92469 5.57459 0 11.6499 0C17.7252 0 22.6499 4.92469 22.6499 11C22.6499 17.0753 17.7252 22 11.6499 22V20.5C16.8968 20.5 21.1499 16.2469 21.1499 11Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8198 6.84961C12.2575 6.84963 12.6108 7.20393 12.6108 7.6416V10.3779H15.3481C15.7858 10.3779 16.1401 10.7322 16.1401 11.1699C16.1401 11.6076 15.7858 11.9609 15.3481 11.9609H12.6108V14.6982C12.6108 15.1359 12.2575 15.4902 11.8198 15.4902C11.3821 15.4902 11.0278 15.1359 11.0278 14.6982V11.9609H8.2915C7.85383 11.9609 7.49953 11.6076 7.49951 11.1699C7.49951 10.7322 7.85382 10.3779 8.2915 10.3779H11.0278V7.6416C11.0278 7.20392 11.3821 6.84961 11.8198 6.84961Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_2915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.649902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/icon-plus-circle.466c38d39ccd4305a13980941c58f680.svg";
export { ForwardRef as ReactComponent };